import { useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { FirstRunTourGate } from '@/tour/sakTour';

export function DashboardLayout() {
  const { isAuthenticated, isLoading, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate('/auth/login');
    }
  }, [isAuthenticated, isLoading, navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-accent"></div>
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return null;
  }

  return (
    <div className="flex min-h-0 flex-1 flex-col bg-background">
      {/* First-run tour: auto-starts once (docs/product/onboarding-tour). */}
      <FirstRunTourGate />
      {/* Full-bleed and full-height: the drive surface stretches to fill the
          pane (flex column — children stretch without percentage heights)
          and manages its own padding. */}
      <main className="flex min-w-0 flex-1 flex-col" data-suite-selectable>
        <Outlet />
      </main>
    </div>
  );
}
